import { TrackingClient } from '@sparefoot/tracking-client';
import { trackCTAClick } from 'components/core/library/tracking-utils/tracking/clickTrackingUtils';

// Used by the inline per-unit "Reserve Now, Pay Later" button. Not shared with
// the mobile sticky Reserve Now bar: the sticky bar has no specific unit to
// report and only scrolls to #units, so it fires its own trackCTAClick call
// (see handleStickyReserveClick in FacilityPageV2) instead of calling this.
export function createReserveClickHandler({ facility, unit }) {
	return () => {
		trackCTAClick(
			'reserve-now-button',
			'Reserve Button',
			'Reserve Now, Pay Later',
			unit.url,
		);

		TrackingClient.trackFacilityUnitSelected({
			facility: {
				id: facility?.id || 'Unknown Facility ID',
				name: facility?.name || 'Unknown Facility',
				location: `${facility?.location?.city || 'Unknown City'}, ${facility?.location?.state || 'Unknown State'}`,
			},
			last_unit_added_date: new Date(),
			unit: {
				currency: 'usd',
				id: unit.id,
				variant_size: unit?.sizeText || 'Unknown Size',
				price: unit?.price?.sparefoot || 'Unknown Price',
				quantity: 1,
			},
			unit_id: unit.id,
			unit_promo: unit.promotion || 'No Promo',
		});
	};
}

export default createReserveClickHandler;
